import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=36b53f0c&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b53f0c",
  null
  
)

export default component.exports